import React, { Fragment, useState } from "react";
import { Prompt } from "react-router-dom";
import { withAuthProvider } from "../../../lib/auth";
import { pathOr } from "ramda";
import ModalView from "./ModalView";
import { isPrivateRoute, isAuthRedirect } from "./utils";

export const isPromptActive =
  ({ setModal, isLoggedIn }) =>
  (nextLocation) => {
    const isPrivate = isPrivateRoute(nextLocation);
    const authRedirect = isAuthRedirect(nextLocation);

    if (authRedirect) {
      setModal({
        open: true,
        returnLink: pathOr(
          nextLocation.pathname,
          ["state", "from"],
          nextLocation,
        ),
      });
    }

    if (!isLoggedIn && isPrivate) {
      setModal({
        open: true,
        returnLink: pathOr(
          nextLocation.pathname,
          ["state", "from"],
          nextLocation,
        ),
      });
      return false;
    }
    return true;
  };

export const PromptModalView = ({ isLoggedIn }) => {
  const [modalState, setModalState] = useState({
    open: false,
    returnLink: "/",
  });

  const setModal = (newState) => {
    if (typeof newState === "boolean") {
      setModalState((prev) => ({ ...prev, open: newState }));
    } else {
      setModalState(newState);
    }
  };

  return (
    <Fragment>
      <Prompt when message={isPromptActive({ setModal, isLoggedIn })} />
      <ModalView
        open={modalState.open}
        onConfirm={setModal}
        onCancel={setModal}
        returnLink={modalState.returnLink}
      />
    </Fragment>
  );
};

export const PromptModal = withAuthProvider(PromptModalView);

export default PromptModal;
